import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Check = ({ svgClass, pathClass }) => {
  return (
    <svg className={svgClass} viewBox="0 0 32 32">
      <path
        className={pathClass}
        d="M21.0647989,10.359 L13.3527989,19.551 L10.2847989,
        16.978 C9.86879894,16.628 9.23379894,
        16.68 8.87879894,17.102 L8.23579894,17.87 C7.87779894,18.297 7.93479894,18.922 8.35679894,
        19.276 L12.9577989,23.137 C13.1657989,23.311 13.4287989,23.386 13.6847989,23.364 L13.6867989,
        23.366 C13.9417989,23.343 14.1877989,23.222 14.3647989,23.011 L23.3627989,12.287 C23.7207989,
        11.862 23.6637989,11.233 23.2407989,10.879 L22.4737989,10.234 C22.2847989,10.077 22.0577989,
        10 21.8317989,10 C21.5457989,10 21.2627989,10.122 21.0647989,10.359 Z"
      />
    </svg>
  );
};

Check.propTypes = {
  svgClass: PropTypes.string,
  pathClass: PropTypes.string,
};

export default Check;



// WEBPACK FOOTER //
// ./src/select-mark/__partials/check.jsx